"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardIndexMapping = void 0;
const card_disclosure_1 = require("./card-disclosure");
const card_id_1 = require("./card-id");
const logic_types_1 = require("../logic-types");
const logic_metrics_1 = require("../logic-metrics");
class CardIndexMapping {
    get disclosedCardCount() {
        return Array.from(this.indexMapping.values()).filter((item) => item.disclosureStatus === logic_types_1.CardDisclosureStatus.Completed).length;
    }
    constructor() {
        this.indexMapping = new Map();
    }
    cardIdForIndex(index) {
        const result = this.getCardIndex(index);
        return result === null || result === void 0 ? void 0 : result.cardId;
    }
    resetDeck() {
        const totalCards = logic_metrics_1.LogicMetrics.DeckCards * logic_metrics_1.LogicMetrics.NumberDecks * 3;
        for (let index = 0; index < totalCards; ++index) {
            this.setCardIndex(index, new card_disclosure_1.CardDisclosure(logic_types_1.CardDisclosureStatus.None));
        }
    }
    dealDeck(indexes, ids) {
        for (let index = 0; index < indexes.length; ++index) {
            const cardId = new card_id_1.CardId(ids[index]);
            this.setCardIndex(indexes[index], new card_disclosure_1.CardDisclosure(logic_types_1.CardDisclosureStatus.Completed, cardId));
        }
    }
    peekDeck(index) {
        this.setCardIndex(index, new card_disclosure_1.CardDisclosure(logic_types_1.CardDisclosureStatus.Completed));
    }
    setStatusWhenNoneForIndex(cardIndex, status) {
        const cardDisclosureStatus = this.getCardIndex(cardIndex);
        if ((cardDisclosureStatus === null || cardDisclosureStatus === void 0 ? void 0 : cardDisclosureStatus.disclosureStatus) === logic_types_1.CardDisclosureStatus.None) {
            cardDisclosureStatus.disclosureStatus = status;
        }
    }
    setStatusWhenPendingHiddenForIndex(cardIndex, status) {
        const cardDisclosureStatus = this.getCardIndex(cardIndex);
        if ((cardDisclosureStatus === null || cardDisclosureStatus === void 0 ? void 0 : cardDisclosureStatus.disclosureStatus) ===
            logic_types_1.CardDisclosureStatus.PendingHidden) {
            cardDisclosureStatus.disclosureStatus = status;
        }
    }
    setStatusWhenPendingForIndex(cardIndex, status) {
        const cardDisclosureStatus = this.getCardIndex(cardIndex);
        if ((cardDisclosureStatus === null || cardDisclosureStatus === void 0 ? void 0 : cardDisclosureStatus.disclosureStatus) === logic_types_1.CardDisclosureStatus.Pending) {
            cardDisclosureStatus.disclosureStatus = status;
            return true;
        }
        return false;
    }
    setCardIndex(index, card) {
        this.indexMapping.set(index, card);
    }
    getCardIndex(index) {
        return this.indexMapping.get(index);
    }
}
exports.CardIndexMapping = CardIndexMapping;
